import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class AddonPacksService {

    Addaddonpacks = async (packs) => {
        return Auth.post('/addon-packs', packs)
    };

    GetById(packid) {
        return Auth.get(`/addon-packs/${packid}`)
    }
    UpdateByID(packs, packid){
        return Auth.put(`/addon-packs/${packid}`, packs)
    }

    DeleteById(packid) {
        return Auth.delete(`/addon-packs/${packid}`)
    }

    GetAllAddonPacks() {
        return Auth.get(`/addon-packs`)
    }

    GetAllAddonPacksForPublic() {
        return Auth.get(`/addon-packs/active/all`)
    }
    
    GetAddonPackByIdPublic(addonPackId) {
        return Auth.get(`/addon-packs/active/${addonPackId}`)
    }

    GetpurchasedAddonPacks() {
        return Auth.get(`/addon-packs/points-history`)
    }

}

export default AddonPacksService

